import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cpqsk65pdp: FaireBrandEntity = {
  token: "b_cpqsk65pdp",
  type: "brand",
  name: "Soul Shine Maine",
  avatarUrl:
    "https://cdn.faire.com/fastly/ef37e0c1563f56480f11544fa1a40ee73990f359ed4806ab720097b3123d37ae.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/021eed1cea8f1f6c9a78c631b78224fa809d0a3471991200389561528b4ac688.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ef37e0c1563f56480f11544fa1a40ee73990f359ed4806ab720097b3123d37ae.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/021eed1cea8f1f6c9a78c631b78224fa809d0a3471991200389561528b4ac688.jpeg",
  location: "Berwick, ME, USA",
  minimumOrderDollars: 125,
  rating: 5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    "Soul Shine Tie Dye and Screen Printing is located in Somersworth, New Hampshire. A woman owned and operated business, offering high quality handmade and hand dyed clothing, housewares and gifts.\nA rainbow of color and unique designs. Proudly featuring many items Made in the USA, hand sewn and/or organic and sustainable fabrics. All hand dyed by our artists at our studio. ",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:15.839Z",
    importedBy: "entity-db-cli",
  },
};
